const trackGoogleAnalyticsEvent = eventData => {
	const trackingObject =
		typeof window === 'object' ? window.jQuery(document) : {};

	const defaultClickEvent = {
		event: 'widgetUserEvent',
		action: 'clicked',
		widgetState: 'default',
		fieldValue: undefined,
		formId: undefined,
		formEventId: undefined,
		value: undefined
	};

	if (Object.keys(trackingObject).length > 0) {
		trackingObject.trigger('trackEvent', {
			...defaultClickEvent,
			...eventData
		});
	}
};

export const triggerExpandReviewEvent = (
	element,
	elementCTA,
	result,
	windowId = 'kbb-reviews1',
	widgetName = 'ws-kbb-reviews'
) => {
	const eventData = {
		element,
		elementCTA,
		result,
		windowId,
		widgetName
	};
	trackGoogleAnalyticsEvent(eventData);
};
